const height_mapping = {
  1: 'margin-1',
  2: 'margin-2',
  3: 'margin-3',
  4: 'margin-4',
};

export const project_height = (item) => {
  let margin = null;
  if (!item) {
    margin = 0;
  } else {
    margin = height_mapping[item];
  }
  return margin;
};
